import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {MemberSearchPageComponent} from "../member-search-page/member-search-page.component";

export class MemberReportSelectionData extends EntityData<MemberReportSelectionData> {
    @identifier memberId: string;
    @field memberFirstName: string;
    @field memberLastName: string;
    @field membershipType: string;
    @field memberNo: string;
}

@Component({
    selector: "wbo-member-report-selection",
    templateUrl: "./member-report-selection-control.component.html"
})
export class MemberReportSelectionControlComponent {

    MemberSearchPageComponent = MemberSearchPageComponent;

    fieldName: string = "members";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromMember(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((member: any) => member.memberId === item.memberId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
